import React from 'react';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Accommodation from './components/Accommodation';
import Culinary from './components/Culinary';
import Location from './components/Location';
import SocialProof from './components/SocialProof';
import FloatingNav from './components/FloatingNav';
import { motion } from 'framer-motion';
import './App.css';

function App() {
  return (
    <motion.div 
      className="app-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <FloatingNav />
      <Hero />
      <Experience />
      <Accommodation />
      <Culinary />
      <Location />
      <SocialProof />
    </motion.div>
  );
}

export default App;